module.exports = __webpack_public_path__ + "732389ded34cb9c52dd88271f1345af9.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/fonts/element-icons.ttf
// module id = 135
// module chunks = 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19